// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1GgPG","modalFooterButton":"ModalNotes_modalFooterButton__32fUJ"};